<template>
    <div>
        <el-row>
            <el-col :span="20">
                <el-tabs v-model="activeName" type="card" class="mt-3" @tab-click="$GFUN.pageChange(1);hotel_name = ''; subdate = []; getDataLists()">
                    <el-tab-pane label="全部" name="all" />
                    <el-tab-pane name="0">
                        <label slot="label">未推送<span v-show="unread > 0">({{unread}})</span></label>
                    </el-tab-pane>
                    <el-tab-pane name="1">
                        <label slot="label">已推送<span v-show="alread > 0">({{alread}})</span></label>
                    </el-tab-pane>
                    <el-tab-pane name="2">
                        <label slot="label">已取消<span v-show="caread > 0">({{caread}})</span></label>
                    </el-tab-pane>
                    <el-tab-pane name="yesterday">
                        <label slot="label">昨日提交<span v-show="ytdalread > 0">({{ytdalread}})</span><span class="unread-msg" style="left:75px" v-show="ytdread > 0">{{ytdread}}</span></label>
                    </el-tab-pane>
                    <el-tab-pane name="other">
                        <label slot="label">其他未推送<span class="unread-msg" style="left:85px" v-show="unread > 0">{{unread}}</span></label>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
            <el-col :span="4" class="text-right">
                <el-button type="primary" size="small" class="mt-3" v-if="activeName == 'yesterday' || activeName == 'other'" @click="batchDetail">批量推送</el-button>
                <div class="text-link mt-4" v-if="activeName == '1'" @click="recordDetail">推送记录</div>
            </el-col>
        </el-row>
        <div class="d-flex align-items-center mt-4" v-if="activeName !== 'yesterday' && activeName !== 'other'">
            <left-text-border required class="mr-5" leftText="酒店名称" v-model="hotel_name"/>
            <left-text leftText="提交时间"/>
            <el-date-picker
                v-model="subdate"
                type="daterange" size="small"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期" />
            <el-button type="primary" size="small" class="ml-5" @click="page = 1;getDataLists()">搜索</el-button>
        </div>
        <el-table :data="tableData" class="mt-4" style="width: 100%" ref="multipleTable" @selection-change="handleSelectionChange">
            <el-table-column type="selection"  width="55" v-if="activeName == 'yesterday' || activeName == 'other'" />
            <el-table-column label="酒店名称">
                <template slot-scope="scope">
                    <el-popover placement="right" trigger="hover">
                        {{scope.row.store_title}}<span slot="reference">{{scope.row.store_title | formatString(10)}}</span>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column label="类型" width="80">
                <template slot-scope="scope">
                    <div v-if="scope.row.roomstate_type == '1'">表格模式</div>
                    <div v-else>文字模式</div>
                 </template>
            </el-table-column>
            <el-table-column label="区域">
                <template slot-scope="scope">
                    {{scope.row.proName}}/{{scope.row.cityName}}/{{scope.row.disName}}
                 </template>
            </el-table-column>
            <el-table-column label="星级">
                <template slot-scope="scope">
                    {{scope.row.star | formatVar('HotelStar')}}
                </template>
            </el-table-column>
            <el-table-column label="提交时间">
                <template slot-scope="scope">
                    <div>{{scope.row.time | formatTimestamp(1)}}</div>
                </template>
            </el-table-column>
            <el-table-column label="状态">
                <template slot-scope="scope">
                    <div :class="{'text-danger': scope.row.status == 0}">
                        <div v-if="scope.row.status == 0" class="text-danger">未推送</div>
                        <div v-if="scope.row.status == 1" class="text-blue">已推送</div>
                        <div v-if="scope.row.status == 2">已取消</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <span class="text-link mr-2"  v-if='scope.row.status == 0' @click="goDetail(scope.row.store_id,scope.row.store_type,scope.row.id,activeName,'edit')">编辑</span>
                    <span class="text-link"  @click="goDetail(scope.row.store_id,scope.row.store_type,scope.row.id,activeName)">查看</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background layout="prev, pager, next" class="mt-4"
                        v-if="AdminDataLists.total > 0"
                         :total="AdminDataLists.total" :current-page=page
                         @current-change="v => this.page=v"/>
    </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
export default {
    name: 'RoomType',
    props: ['infoList'],
    data () {
        return {
            activeName: 'all',
            unread: 0,
            alread: 0,
            caread: 0,
            ytdread: 0,
            ytdalread: 0,
            elseread: 0,
            hotel_name: '',
            subdate: [],
            tableData: [],
            page: 1,
            total: 1,
            localHotelId: [],
            page: 1,
            transfer: []
        }
    },
    computed: {
      ...mapState(['AdminDataLists', 'newMessageInform']),
      ...mapGetters(['storeInfo']),
      queryCon() { return this.$route.query },
    },
    watch: {
        infoList () { this.tableData = this.infoList },
        newMessageInform(newVal) {
            if (this.newMessageInform.type === 33 || this.newMessageInform.type === 34) {
                this.getNums(); this.getDataLists(); this.$emit('getState'); this.getWaitHandleData()
            }
        },
        page () { this.getDataLists() },
        activeName () { this.page = 1 }
    },
    created () {
        if(this.queryCon.active) this.activeName = this.queryCon.active
        this.getNums()
    },
    methods: {
        ...mapMutations(['UPDATECURRENTSTORE']),
        ...mapActions(['getAdminDataLists', 'getWaitHandleData']),
        //表头自定义
        renderHeader (h,{column}) {
            return h(
                'div',[
                    h('span', column.label),
                    h('i', {
                        class:'el-icon-edit',
                        style:'color:#60c9fd;margin-left:5px;'
                    })
                ],
            );
        },
        // 昨日提交和未推送的批量推送id
        handleSelectionChange (val) {
            this.multipleSelection = val;
            this.transfer = this.multipleSelection.map(v => { v.index = 1; return v})
        },
        // 获取数据列表
        getDataLists() {
            this.UPDATECURRENTSTORE({type:Number(this.queryCon.storeType)});
            let data = {
                page: this.page,
                status:  this.activeName == 'all' ? '' : this.activeName,
                store_title: this.hotel_name,
                start_time: this.subdate.length > 0 ? Math.round(new Date(this.subdate[0]).getTime() / 1000) : '',
                end_time: this.subdate.length > 0 ? Math.round((new Date(this.subdate[1]).getTime() + 24 * 60 * 60 * 1000 - 1) / 1000) : ''
            }
            if (this.activeName == 'other' || this.activeName == 'yesterday') {data.num = '';data.page = ''}
            this.getAdminDataLists({
                type: 'roomTypeTrends',
                data
            });
        },
        // 跳转详情
        goDetail (store_id,type,room_state_id,activeName,edit) {
            let routeUrl
            if (edit) routeUrl = this.$router.resolve({name:'RoomDetail',query:{store_id,type,room_state_id,activeName,edit}})
            else routeUrl = this.$router.resolve({name:'RoomDetail',query:{store_id,type,room_state_id}})
            window.open(routeUrl.href, '_blank');
        },
        // 推送另开一页跳转
        recordDetail () {
            let routeUrl = this.$router.resolve({name:'PushRecord'});
            window.open(routeUrl.href, '_blank');
        },
        //批量推送跳转详情页
        batchDetail () {
            if (!this.multipleSelection) {this.$message.warning('请选择批量推送酒店'); return}
            sessionStorage.setItem('batchmul', JSON.stringify(this.transfer))
            let routeUrl = this.$router.resolve({name:'RoomBatchDetail'});
            window.open(routeUrl.href, '_blank');
        },
        //获取各状态数据
        async getNums () {
            // let res = await this.$axios.post('pc/Admin/getRoomStateStatus',{})
            // if (res.code === '00000') {
            //     this.unread = res.info.status0
            //     this.alread = res.info.status1
            //     this.caread = res.info.status2
            //     this.ytdread = res.info.yesterday_status0
            //     this.ytdalread = res.info.yesterday_status1 + res.info.yesterday_status2
            // }
        }
    }
}
</script>

<style lang="scss" scoped>
.unread-msg {
    top: 0;
    left: 58px;
}
</style>
